import { Alert, Icon } from '@oscar/theme';
import { MESSAGE_NOTICE } from 'common/constants';
import React, { useState } from 'react';
import './style.scss';

export default function MessageSuccess(props: {
  type: string;
  message: string;
}) {
  const { type, message } = props;
  const [isShow, setIsShow] = useState(true);
  setTimeout(() => {
    setIsShow(false);
  }, 5000);
  return (
    <>
      {isShow && type === MESSAGE_NOTICE.SUCCESS && (
        <div className="message-success">
          <Alert
            message={message}
            showIcon
            icon={<Icon icon={'process-icon-done'} />}
          />
        </div>
      )}
      {isShow && type === MESSAGE_NOTICE.ERROR && (
        <div className="message-error">
          <Alert message={message} showIcon icon={<Icon icon={'error'} />} />
        </div>
      )}
    </>
  );
}
